class Exception extends Error {
  constructor(title, message) {
    super();
    this.name = this.constructor.name;
    this.title = title;
    this.message = message;

    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, this.constructor);
    } else {
      this.stack = new Error(message).stack;
    }
  }
}

// Exception.prototype = Object.create(Error.prototype);
// Exception.prototype.constructor = Exception;

export default Exception;
